import { Contact } from "./contact.model";
import {Claim} from "./claim.model";
export class Group {
    active: boolean = true;
    groupType: string = "";
    displayName: string = "";
    id: string = "";
    permissions: Claim[] = [];
    users: Contact[] = [];
}

export class GroupStub{
    displayName: string = "";
    id: string = "";
}
